var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg58(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "phosphor icons / ChartLine"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 3.625C2.84518 3.625 3.125 3.90482 3.125 4.25V16.125H17.5C17.8452 16.125 18.125 16.4048 18.125 16.75C18.125 17.0952 17.8452 17.375 17.5 17.375H2.5C2.15482 17.375 1.875 17.0952 1.875 16.75V4.25C1.875 3.90482 2.15482 3.625 2.5 3.625Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9704 7.58844C18.1977 7.84822 18.1713 8.24307 17.9116 8.47037L12.9116 12.8454C12.6893 13.0398 12.3613 13.0522 12.125 12.875L7.5303 9.42898L2.91157 13.4704C2.6518 13.6977 2.25695 13.6713 2.02965 13.4116C1.80235 13.1518 1.82867 12.7569 2.08844 12.5296L7.08844 8.15465C7.3107 7.96017 7.63875 7.94781 7.87501 8.12501L12.4697 11.571L17.0884 7.52965C17.3482 7.30235 17.7431 7.32867 17.9704 7.58844Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg58);
export default __webpack_public_path__ + "static/media/svg58.4a7dd2dd7d9f6156c09e36815fce49ae.svg";
export { ForwardRef as ReactComponent };